import React from "react";

const fmt = (value, currency) => {
  if (value === null || value === undefined) return "—";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `$${Number(value).toFixed(2)}`;
  }
};

const Metric = ({ label, value, currency, valueClass }) => (
  <div className="flex flex-col">
    <span className="text-dense-xs text-gray-500">{label}</span>
    <div className={`mt-fluid-0.25 px-fluid-2 py-fluid-1.5 rounded-md border border-gray-300 bg-[#FAFAFB] text-fluid-sm font-semibold tabular-nums ${valueClass}`}>
      {fmt(value, currency)}
    </div>
  </div>
);

const ParentChargeSummary = ({ revenue, cost, profit, currency }) => {
  if (revenue === null && cost === null && profit === null) return null;

  const profitClass =
    profit === null ? "text-gray-800" : profit >= 0 ? "text-emerald-600" : "text-rose-600";

  return (
    <div className="grid grid-cols-3 gap-x-fluid-2 px-fluid-3 py-fluid-2 bg-[#F9FAFE] border-b border-gray-200">
      {revenue !== null && (
        <Metric label="Total Revenue" value={revenue} currency={currency} valueClass="text-[#223688]" />
      )}
      {cost !== null && (
        <Metric label="Total Cost" value={cost} currency={currency} valueClass="text-gray-800" />
      )}
      {profit !== null && (
        <Metric label="Profit" value={profit} currency={currency} valueClass={profitClass} />
      )}
    </div>
  );
};

export default ParentChargeSummary;
